import React from "react"

import { useState, useEffect, useCallback, useContext } from 'react'

import DodonesDayShow from 'app/dodones/day/Show'
import DodonesGenericShow from 'app/dodones/generic/Show'
import DodonesRecordableProgressionShow from 'app/dodones/recordable_progression/Show'
import DodonesBirlExerciseShow from 'app/dodones/birl_exercise/Show'

import DodoneContext from 'app/dodones/Context'
import HeaderContext from 'app/HeaderContext'
import DodoneMenu from 'app/dodones/Menu'
import DodoneIgnoredBanner from 'app/dodones/shared/IgnoredBanner'
import DodoneProofTrigger from 'app/dodones/proofs/Trigger'

function resolveShowView(typeViewPrefix) {
  if(typeViewPrefix == 'Day')
    return DodonesDayShow

  if(typeViewPrefix == 'RecordableProgression')
    return DodonesRecordableProgressionShow

  if(typeViewPrefix == 'BirlExercise')
    return DodonesBirlExerciseShow

  // if(typeViewPrefix == 'Generic')
  // if(typeViewPrefix == 'Birl')
  return DodonesGenericShow
}

export default () => {
  const dodoneContext = useContext(DodoneContext)
  const dodone = dodoneContext.dodone
  const { setContextualMenu } = useContext(HeaderContext)

  useEffect(() => {
    if (!dodone) {
      setContextualMenu(null)
      return
    }

    // Create menu component that captures the current dodone
    const DodoneSpecificMenu = (menuProps) => {
      return <DodoneMenu { ...dodoneContext } { ...menuProps } />
    }

    setContextualMenu(() => DodoneSpecificMenu)

    return () => setContextualMenu(null)
  }, [dodone, setContextualMenu])

  const DodonesSelectedShow = resolveShowView(dodone.dodoable.typeViewPrefix)

  return <>
           <DodoneProofTrigger dodone={ dodone } showTextStatus={ true } />
           <DodoneIgnoredBanner dodone={ dodone } />
           <DodonesSelectedShow />
         </>
}
